import { useEffect, useRef, useState } from 'react';

import styled from 'styled-components';

import BREAKPOINTS from 'styles/breakpoints';
import { rem, weight } from 'styles/typography';
import COLORS from 'styles/colors';

import { AWS_S3_BUCKET_URL } from 'utils/constants';

const Section = styled.div`
  min-height: 540px;
  background: ${({ bgImg }) => (bgImg ? `url(${bgImg.mobile})` : 'none')}
    no-repeat center top;
  background-size: cover;
  position: relative;

  ${BREAKPOINTS.small`
    min-height: 100vh;
    background-image: ${({ bgImg }) => (bgImg ? `url(${bgImg.url})` : 'none')};
  `}
`;

const BackgroundVideo = styled.video`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Overlay = styled.div`
  position: relative;
  padding: 30px var(--gutter-side) 95px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
  min-height: inherit;
  background-color: ${COLORS.black.opacity(0.2)};
  color: ${COLORS.pinkMillennial};
  text-align: center;

  ${BREAKPOINTS.small`
    padding: 30px var(--gutter-side);
    justify-content: center;
  `}
`;

const Title = styled.h1`
  font-size: clamp(${rem(50)}, 14vw, ${rem(70)});
  line-height: ${rem(75)};
  font-weight: ${weight.black};

  ${BREAKPOINTS.medium`
    font-size: ${rem(104)};
    line-height: ${rem(97)};
  `}

  ${BREAKPOINTS.large`
    font-size: ${rem(120)};
    line-height: ${rem(120)};
  `}
`;

const Hero = ({ page }) => {
  const [videoError, setVideoError] = useState(false);
  const videoRef = useRef(null);

  const { title, heroVideoUrl, heroAsset, videoPoster } = page;

  // Check if video fails to load
  useEffect(() => {
    const video = videoRef?.current;

    const onError = () => {
      setVideoError(true);
    };

    video?.addEventListener('error', onError);
    video?.addEventListener('abort', onError);
    return () => {
      video?.removeEventListener('error', onError);
      video?.removeEventListener('abort', onError);
    };
  }, []);

  return (
    <Section bgImg={heroAsset}>
      {!heroAsset && heroVideoUrl && (
        <>
          <BackgroundVideo
            ref={videoRef}
            muted
            playsInline
            autoPlay
            loop
            poster={videoError ? videoPoster?.url : null}
          >
            <source
              src={`${AWS_S3_BUCKET_URL}/${heroVideoUrl}`}
              type="video/mp4"
            />
          </BackgroundVideo>
        </>
      )}
      <Overlay>
        <Title>{title}</Title>
      </Overlay>
    </Section>
  );
};

export default Hero;
